export default {
  club_name: 'Falkenbergs FF',
  club_name_short: 'falkenbergsff',
  stadium_name: '',
  staging_url: 'https://falkenbergsff.api.fangroup.io',
  prod_url: 'https://falkenbergsff.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/falkenbergsff',
  club_logo: '/assets/teams/falkenbergsff.png',
  app_name: 'falkenbergsff',
  websale_name: 'falkenbergsff',
  ntb_team_id: 10067,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'falkenbergsff',
  monolithEnabled: false,
};
